import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/banner/banner/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/banner/banner/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/banner/banner/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/banner/banner/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/banner/banner/detail',
    method: 'get',
    params: { id }
  })
}
export function putStatus(data) {
  return request({
    url: '/banner/banner/update',
    method: 'post',
    data
  })
}
